import axios from 'axios';

const SERVER_URL = process.env.VUE_APP_SERVER_URL || 'https://comprasserver.dallastratech.com/';

const api = axios.create({
  baseURL: SERVER_URL,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      // eslint-disable-next-line no-param-reassign
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

export default api;
